
export default function SymbolAvgHz({id, fontSize, txtColor, overlineColor}) {
    return (<symbol id={id} viewBox="0 0 40 20">
        <text
            x={5}
            y={20}
            // dominantBaseline="middle"
            // textAnchor="middle"
            fontSize={fontSize??"20"}
            // fontFamily="Arial, sans-serif"
            fill={txtColor??"black"}
        >Hz</text>
        <line x1={5} y1={1} x2={28} y2={1} stroke={overlineColor??"green"} strokeWidth="2" />
    </symbol>);
}